import { useTheme } from '@mui/material/styles'
import logo_sentinela from 'assets/logo_sentinela.png'
import logo_sentinela_black from 'assets/logo_sentinela_black.png'

/**
 * Hook that returns the appropriate logo based on the current theme mode
 * @returns {string} - Logo path for current theme (light/dark)
 */
export const useLogo = () => {
  const theme = useTheme()

  return theme.palette.mode === 'dark' ? logo_sentinela_black : logo_sentinela
}
